import { render, staticRenderFns } from "./BrowseSilenceTip.vue?vue&type=template&id=f68d5e8a&"
import script from "./BrowseSilenceTip.vue?vue&type=script&lang=js&"
export * from "./BrowseSilenceTip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports